import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { PowerplatformAgentActionAuthenticationMode } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { AutonomousWithTriggersComponent } from '../../common/autonomous-with-triggers/autonomous-with-triggers.component';
import { IAutonomousWithTriggersComponent } from '../../common/interfaces/autonomous-with-triggers.interface';

@Component({
  selector: 'app-set-authentication-mode',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe, AutonomousWithTriggersComponent],
  templateUrl: './set-authentication-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetAuthenticationModeComponent implements IAutonomousWithTriggersComponent {
  public fg = input.required<UntypedFormGroup>();
  public selectedAuthenticationMode = model.required<PowerplatformAgentActionAuthenticationMode>();
  public labelKey = input.required<string>();
  public authenticationModeOptions = PowerplatformAgentActionAuthenticationMode;
  public ignoreIfAutonomousWithTriggers = model.required<boolean>();

  // Properties expected by the template
  public authenticationMode = this.selectedAuthenticationMode;
  public authenticationModeEnum = PowerplatformAgentActionAuthenticationMode;

  public getLabelKey(): string {
    return this.labelKey();
  }

  public onRadioButtonChange(value: PowerplatformAgentActionAuthenticationMode): void {
    this.selectedAuthenticationMode.set(value);
  }
}
